<template>
  <div>

    <div class="modal fade" tabindex="-1" role="dialog" id="newAddressModal">

      <div class="modal-dialog" role="document">

        <div class="modal-content">

          <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title" v-if="modalType == 'new'">Skapa ny adress</h4>
            <h4 class="modal-title" v-if="modalType == 'edit' && clinic.address">Redigerar {{
                clinic.address.street
              }}</h4>

          </div>

          <div class="modal-body">

            <div class="form-group">
              <label for="name_clinic" class="control-label">Titel</label>
              <input type="text" v-model="toAdd.title" class="form-control">
            </div>

            <div class="form-group">
              <label for="co" class="control-label">c/o Adress</label>
              <input type="text" v-model="toAdd.co" class="form-control">
            </div>

            <div class="form-group">
              <label for="name_clinic" class="control-label">Gata</label>
              <input type="text" v-model="toAdd.street" class="form-control">
            </div>

            <div class="form-group">
              <label for="name_clinic" class="control-label">Stad</label>
              <input type="text" v-model="toAdd.city" class="form-control">
            </div>

            <div class="form-group">
              <label for="name_clinic" class="control-label">Stadsdel</label>
              <input type="text" v-model="toAdd.city_area" class="form-control">
            </div>

            <div class="form-group">
              <label for="name_clinic" class="control-label">Postnummer</label>
              <input type="text" v-model="toAdd.zip" class="form-control">
            </div>

          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-primary" v-on:click="createNewAddress()">Spara</button>

          </div>

        </div><!-- /.modal-content -->

      </div><!-- /.modal-dialog -->

    </div>

    <div class="panel panel-clinic">

      <div class="panel-heading collapsed" href="#form_contact" data-toggle="collapse">

        <div class="arrow-down"></div>

        <h2 class="panel-title">Kontaktuppgifter - partner</h2>

      </div>

      <div id="form_contact" class="panel-collapse collapse">

        <div class="panel-body">

          <!-- <button v-on:click="crash()">Crash page</button> -->

          <div class="form-horizontal">

            
            <row-text :model.sync="clinic.name_company_contact" text="Kontaktperson / Firmatecknare"></row-text>
            <row-text :model.sync="clinic.name_company" text="Företagsnamn"></row-text>
            <row-text :model.sync="clinic.contact_phone" text="Telefonnummer för kontakt" :asterisk="false"></row-text>

            <row-text
              :model.sync="clinic.org_number"
              text="Organisationsnummer (behövs innan skarpt avtal skickas ut)"
              :asterisk="false">
            </row-text>

            <div id="address" class="row-adress oddevencol">

              <div class="adrcol1">
                <b>Mottagningsadress – att läggas upp vid anslutning</b>
              </div>

              <div class="adrcol2">

                <div style="float:left; width:55%; margin-right:5%; padding-right:5%; height:100%; min-height:70px;">

                  <div v-if="clinic.address">

                    <b>{{ clinic.address.street }}</b>

                    <br>

                    <span v-if="clinic.address.co">{{ clinic.address.co }}<br></span>

                    {{ clinic.address.zip }} {{ clinic.address.city }}

                  </div>

                </div>

                <div style="float: left; width: 40%;">
                  <i>Redigeras under fliken "Adress".</i>
                </div>

              </div>

            </div>

            <row-text :model.sync="clinic.address_home" text="Postadress" :asterisk="false"></row-text>

            <row-text :model.sync="clinic.address_company" text="Företagsadress"
                      comment="Adress som anges på avtalet"></row-text>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :extra-data="[ { value: 1, text: 'Postadressen' }, { value: 2, text: 'Mottagningsadressen' }]"
              type="radio_delivery_address"
              layout="Radio"
              title="Post skickas till"
              comment="Till vilken adress vill partnern att vi skickar post, t ex avtal, snabbguider mm?">
            </row-meta>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :extra-data="[ { value: 1, text: 'Postadressen' }, { value: null, text: 'Mottagningsadressen' }]"
              type="radio_invoice_address"
              layout="Radio"
              title="Adress på självfakturan"
              comment="Vilken adress ska synas på självfakturan?">
            </row-meta>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>

import mixin from './mixin'

export default {

    mixins: [mixin],

    props: {
        product_areas: {
            required: true
        }
    },

    data () {
        return {

            query: '',
            loading: false,
            addresses: [],

            toAdd: {},
            modalType: null

        }
    },

    computed: {

        groupAddon () {
            if (this.loading == 1) {
                return 'fa fa-cog fa-spin'
            }

            return 'fa fa-search'
        },
    },

    watch: {

        query () {
            if (this.query) {
                this.triggerSearch()
            }
        }

    },

    methods: {

        triggerSearch () {
            this.loading = true
            this.search()
        },

        search: _.debounce(
            function () {
                const self = this

                if (!self.query) {
                    self.loading = false
                    self.addresses = []
                    return
                }

                this.$http.post('/clinics/searchAddress', { query: this.query }).then((response) => {
                    console.log(response.body)

                    self.addresses = response.body

                    self.loading = false
                }, (response) => {
                    console.log(JSON.stringify(response))
                })
            }, 500
        ),

        choose (address) {
            this.clinic.address = address
            this.clinic.address_id = address.id

            this.query = ''
            this.addresses = []
        },

        unlink () {
            this.clinic.address = null
            this.clinic.address_id = null
        },

        openModal (type) {
            if (type == 'new') {
                this.modalType = 'new'
                this.toAdd = {}
            } else {
                this.modalType = 'edit'
                this.toAdd = JSON.parse(JSON.stringify(this.clinic.address))
            }

            $('#newAddressModal').modal('show')
        },

        createNewAddress () {
            const self = this

            console.log('save address data')
            console.log(self.toAdd)

            $('#newAddressModal').modal('hide')

            this.$http.post('/clinics/address/add', {

                clinic: self.clinic,
                address: self.toAdd

            }).then((response) => {
                console.log('save address response')
                console.log(response.body)

                self.toAdd = {}

                this.clinic.address = response.body.address
                this.clinic.address_id = response.body.address.id

                // bus.$emit('refresh-data', 1);
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        }

    }

}

</script>
